import React from 'react';

export const SaleIcon = () => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='48'
            height='48'
            viewBox='0 0 48 48'
            fill='none'
        >
            <rect width='48' height='48' rx='8' />
            <path
                d='M40.1109 9.88125L38.1234 7.89375C38.053 7.82396 37.9578 7.78481 37.8586 7.78481C37.7594 7.78481 37.6642 7.82396 37.5938 7.89375L7.88906 37.5891C7.81927 37.6595 7.78012 37.7547 7.78012 37.8539C7.78012 37.9531 7.81927 38.0483 7.88906 38.1188L9.87656 40.1062C10.0219 40.2516 10.2609 40.2516 10.4062 40.1062L40.1062 10.4062C40.2562 10.2656 40.2563 10.0266 40.1109 9.88125ZM14.25 21C17.9719 21 21 17.9719 21 14.25C21 10.5281 17.9719 7.5 14.25 7.5C10.5281 7.5 7.5 10.5281 7.5 14.25C7.5 17.9719 10.5281 21 14.25 21ZM14.25 10.875C16.1109 10.875 17.625 12.3891 17.625 14.25C17.625 16.1109 16.1109 17.625 14.25 17.625C12.3891 17.625 10.875 16.1109 10.875 14.25C10.875 12.3891 12.3891 10.875 14.25 10.875ZM33.75 27C30.0281 27 27 30.0281 27 33.75C27 37.4719 30.0281 40.5 33.75 40.5C37.4719 40.5 40.5 37.4719 40.5 33.75C40.5 30.0281 37.4719 27 33.75 27ZM33.75 37.125C31.8891 37.125 30.375 35.6109 30.375 33.75C30.375 31.8891 31.8891 30.375 33.75 30.375C35.6109 30.375 37.125 31.8891 37.125 33.75C37.125 35.6109 35.6109 37.125 33.75 37.125Z'
                fill='#6257D2'
            />
        </svg>
    );
};
